import React, { Component } from "react";
import { AgServicosCadastrar } from "../cadastrar/telas/AgServicosCadastrar";
import AgServicosStore from "./AgServicosStore";
import { inject, observer } from "mobx-react";
import AgServicosTotalService from "../../../services/AgServicosTotalService";
import { AgServicosVisualizar } from "../visualizar/telas/AgServicosVisualizar";
import lscache from "lscache";

@inject("store")
@observer
export class AgServicosTotal extends Component {
    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;

        this.controller = new AgServicosStore();
        this.service = new AgServicosTotalService();
    };

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Agendamento de Serviços");
        
        let voltarParam = _.get(this.props.location.state,`voltar`);
        
        voltarParam ? lscache.set('acompProcesso-pesquisa-voltar', 5) : false;
        this.props.store.appStore.showVoltarTopBar(voltarParam ? true : false, voltarParam ? voltarParam : '/');
    };

    componentDidUpdate() {
        this.tituloPaginaStore.setTitulo("Agendamento de Serviços Total");
    };

    render() {
        return (
            <div>
                {this.controller.cadastrando
                    && <AgServicosCadastrar service={this.service}
                        controller={this.controller}
                        idEditando={this.controller.idEditando}
                        AgendGrupoServIdMultiplos={this.controller.AgendGrupoServId}
                        AgendTipoServIdMultiplos={this.controller.AgendTipoServId}
                        PlacaMultiplos={this.controller.Placa}
                        HoraAgendMultiplos={this.controller.HoraAgend}
                        DatAgendMultiplos={this.controller.DatAgend}
                />
                }
                <div className={this.controller.cadastrando ? "escondido" : ""} >
                    {/* <Button onClick={() => this.controller.editar(27489)}>27489</Button>
                    <Button onClick={() => this.controller.editar(27485)}>27485</Button> */}
                    <AgServicosVisualizar service={this.service} controller={this.controller} />
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/agendamentoservicosTotal/agservicos/AgServicos.js